import React, { useState, useEffect, useCallback } from "react";
import { Line } from "rc-progress";
import Spinner from "react-bootstrap/Spinner";
import Bunexe_service from "../../../Bunexe_service";
import "./Statns4.css";
import AfficheProgress from "./AfficheProgress";

const ProgressionSaisie = ({ titre_, info_ }) => {
  const url_ = Bunexe_service.url;
  const [numero_correction, setNumero_Correction] = useState("1");
  const [my_progress, setMyProgress] = useState([]);
  const [done, setDone] = useState(false);
  const [dept, setDept] = useState(info_?.code_dept || "");
  const [selectedDept, setSelectedDept] = useState("");

  const updateSelectedDept = useCallback((code_dept) => {
    const de = Bunexe_service.depts.find((d) => d.code === code_dept);
    setSelectedDept(de ? de.Libelle : "");
  }, []);

  const getTotalProgress = useCallback(
    async (prog, currentDept) => {
      setDone(false);
      try {
        const response = await fetch(
          `${url_}/saisie_notes_bac/progression_saisie/${currentDept}/${prog}`,
        );
        const data = await response.json();
        setMyProgress(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur chargement progression :", error);
        setMyProgress([]);
      } finally {
        setDone(true);
      }
    },
    [url_],
  );

  useEffect(() => {
    updateSelectedDept(dept);
    getTotalProgress(numero_correction, dept);
  }, [dept, numero_correction, getTotalProgress, updateSelectedDept]);

  // Calcul propre du taux moyen global sans mutation au moment du render
  const averageRate =
    my_progress.length > 0
      ? my_progress.reduce(
          (acc, curr) => acc + (parseFloat(curr.taux) || 0),
          0,
        ) / my_progress.length
      : 0;

  return (
    <div className="container-fluid">
      {info_?.role_id !== "SADM" && (
        <h3 className="text-center mt-2">{titre_}</h3>
      )}

      <div className="container">
        {info_?.role_id === "SADM" && (
          <div className="row mt-2">
            <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
              <select
                value={dept}
                name="dept"
                className="form-control"
                onChange={(e) => setDept(e.target.value)}
              >
                {Bunexe_service.depts.map((s) => (
                  <option value={s.code} key={s.code}>
                    {s.Libelle}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="row mx-2 mt-2">
          <div className="mt-2 col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
            <div
              style={{ width: "100%", marginBottom: "10px" }}
              className="d-flex justify-content-between"
            >
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="numero_correction"
                  id="correction1"
                  value="1"
                  checked={numero_correction === "1"}
                  onChange={() => setNumero_Correction("1")}
                />
                <label className="form-check-label" htmlFor="correction1">
                  NS-IV
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="numero_correction"
                  id="correction3"
                  value="3"
                  checked={numero_correction === "3"}
                  onChange={() => setNumero_Correction("3")}
                />
                <label className="form-check-label" htmlFor="correction3">
                  Perm. NS-IV
                </label>
              </div>

              <div className="form-check mr-4">
                <input
                  className="form-check-input"
                  type="radio"
                  name="numero_correction"
                  id="correction2"
                  value="2"
                  checked={numero_correction === "2"}
                  onChange={() => setNumero_Correction("2")}
                />
                <label className="form-check-label" htmlFor="correction2">
                  Perm. Philo
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      {!done ? (
        <div className="row">
          <div className="col-6 offset-3 text-center">
            <div className="d-flex justify-content-center align-items-center">
              <h4 className="mr-3">Patientez quelques secondes....</h4>
              <Spinner animation="border" variant="info" />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="container">
            <div className="row pb-2">
              {my_progress.length > 0 &&
                my_progress.map((m, index) => (
                  <div
                    key={index}
                    className="mt-2 col-xs-3 col-sm-4 col-md-3 col-lg-2 text-center"
                  >
                    <AfficheProgress une_donnee={m} />
                  </div>
                ))}
            </div>
          </div>

          <div className="container mt-4">
            <div className="row">
              <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
                <Line
                  percent={averageRate}
                  strokeWidth={3}
                  strokeColor="lightgreen"
                />
              </div>
            </div>
            <div className="row mt-2 mb-4">
              <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
                <span className="font-weight-bold">
                  {selectedDept ? `${selectedDept}, ` : ""}Taux de Saisie Global
                  : {averageRate.toFixed(2)} %
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProgressionSaisie;
